import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
 
const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState("form"); // form | success
  const [message, setMessage] = useState("");
  const [toast, setToast] = useState({ message: "", type: "success", visible: false });
  const [toastType, setToastType] = useState("success"); // success | error
  const [cooldown, setCooldown] = useState(0); // countdown timer
  const navigate = useNavigate();
 
 
  // countdown effect
  useEffect(() => {
    let timer;
    if (cooldown > 0) {
      timer = setInterval(() => setCooldown((prev) => prev - 1), 1000);
    }
    return () => clearInterval(timer);
  }, [cooldown]);
 
  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
 
    try {
      const response = await axios.post("https://teams.tidyds.com/api/forgot-password", {
        email,
      });
 
      if (response.data.success) {
        setStep("success"); // show success screen
      } else {
        setMessage("Email not found. Please try again.");
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setMessage("This email is not registered in our system.");
      } else {
        setMessage("Something went wrong. Please try again later.");
      }
    } finally {
      setLoading(false);
    }
  };
 
  const showToast = (message, type = "success") => {
    setToast({ message, type, visible: true });
    setTimeout(() => {
      setToast((prev) => ({ ...prev, visible: false }));
    }, 3500);
  };
 
  const handleResend = async () => {
    if (cooldown > 0) return;
    setLoading(true);
 
    try {
      await axios.post("https://teams.tidyds.com/api/forgot-password", { email });
 
      // show success popup again
      setStep("success");
 
      // also show toast if you still want it
      showToast("Temporary password resent successfully!", "success");
 
      setCooldown(120);
    } catch {
      showToast("Unable to resend. Please try again later.", "error");
    } finally {
      setLoading(false);
    }
  };
 
 
  return (
    <section className="forgot-wrapper">
      <style>
        {`
          .forgot-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100vh;
            background: linear-gradient(to bottom, #45048a, #ab1599);
          }
          .forgot-card {
            position: relative;
            background: #fff;
            border-radius: 12px;
            padding: 40px 28px;
            width: 100%;
            max-width: 400px;
            text-align: center;
            box-shadow: 0 6px 20px rgba(0,0,0,0.1);
          }
          .toast {
            position: fixed;
            top: 20px;
            left: 50%;
            transform: translateX(-50%);
            background: #28a745; /* default success */
            color: #fff;
            padding: 12px 20px;
            border-radius: 6px;
            font-size: 14px;
            font-weight: 500;
            box-shadow: 0 4px 12px rgba(0,0,0,0.15);
            z-index: 1000;
            animation: fadeInOut 3.5s forwards;
          }
 
          .toast.success { background: #28a745; }
          .toast.error { background: #dc3545; }
 
          @keyframes fadeInOut {
            0% { opacity: 0; transform: translate(-50%, -20px); }
            10% { opacity: 1; transform: translate(-50%, 0); }
            90% { opacity: 1; }
            100% { opacity: 0; transform: translate(-50%, -20px); }
          }
          .forgot-card h2 {
            font-size: 24px;
            font-weight: 600;
            line-height: 32px;
            margin-bottom: 10px;
            color: #000;
          }
          .forgot-card p.subtitle {
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            color: #4A4A4A;
            margin-bottom: 20px;
          }
          .forgot-card input {
            width: 100%;
            padding: 12px;
            border: 1px solid #ddd;
            border-radius: 8px;
            font-size: 14px;
            margin-bottom: 24px;
          }
          .forgot-card input:focus {
            border: 1px solid #000;
          }
          .btn-primary {
            width: 100%;
            background: linear-gradient(to right, #45048a, #45048a);
            border: none;
            border-radius: 8px;
            color: #fff;
            font-weight: 700;
            line-height: 24px;
            padding: 10px;
            font-size: 16px;
            cursor: pointer;
            transition: background 0.3s;
          }
          .btn-primary:hover {
            background: linear-gradient(to right, #6b21bf, #6b21bf);
          }
          .back-link {
            margin-top: 15px;
            font-size: 16px;
            color: #4A4A4A;
            cursor: pointer;
            line-height: 24px;
            text-decoration: none;
          }
          .back-link:hover {
            color: #45048a;
          }
          .message {
            margin: 10px 0;
            font-size: 14px;
          }
          .success-icon {
            width: 50px;
            height: 50px;
            border: 2px solid #28a745;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto 15px;
          }
          .success-icon svg {
            stroke: #28a745;
            stroke-width: 3;
          }
          .resend-link {
            margin-top: 15px;
            font-size: 14px;
            color: #45048a;
            cursor: pointer;
            display: inline-flex;
            align-items: center;
          }
          .resend-link.disabled {
            color: #aaa;
            cursor: not-allowed;
          }
          .resend-link:hover {
            text-decoration: underline;
          }
          .error-input {
            border: 1px solid #dc3545 !important;
            outline: none;
          }
          .error-m {
            color: #dc3545;
            text-align: left;
            font-size: 13px;
            margin-top: -10px;
            margin-bottom: 10px;
          }
          .form-control{
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            color: #bdbdbd;
            padding: 10px;
            border-color: #bdbdbd;
          }
          .form-control:hover{ border-color: #000000 !important; }
          .form-control:focus{ border-color: #000 !important; box-shadow: none !important; }
        `}
      </style>
      {toast.visible && (
        <div className={`toast ${toast.type}`}>
          {toast.message}
        </div>
      )}
      <div className="forgot-card">
        {step === "form" ? (
          <>
            <div style={{ fontSize: "32px", marginBottom: "15px" }}>
              <img src="./Featured icon.webp" alt="mail-icon" className="mail-img" />
            </div>
            <h2 className="f-ps">Forgot your password?</h2>
            <p className="subtitle">
              Enter your registered email address and we’ll send you a temporary password.
            </p>
 
            <form onSubmit={handleForgotPassword}>
              <input
                type="email"
                placeholder="Enter Your Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={`form-control ${message ? "error-input" : ""}`}
                required
              />
              {message && <p className="message error-m">{message}</p>}
              <button type="submit" className="btn-primary" disabled={loading}>
                {loading ? "Sending..." : "Send Temporary Password"}
              </button>
            </form>
 
            <div className="back-link" onClick={() => navigate("/")}>
              ← Back to login
            </div>
          </>
        ) : (
          <>
            <div className="success-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
                <path d="M20 6L9 17l-5-5" />
              </svg>
            </div>
            <h2>Check your inbox!</h2>
            <p className="subtitle">
              We sent a temporary password to <b>{email}</b>
            </p>
            <p className="subtitle">Can’t find the email? Check your spam folder or try again.</p>
 
            <button className="btn-primary" onClick={() => navigate("/")}>
              Back to login
            </button>
 
            <div
              className={`resend-link ${cooldown > 0 ? "disabled" : ""}`}
              onClick={handleResend}
            >
              {loading
                ? "Resending..."
                : cooldown > 0
                ? `Resend available in ${Math.floor(cooldown / 60)}:${(cooldown % 60)
                    .toString()
                    .padStart(2, "0")}`
                : "⟳ Resend temporary password"}
            </div>
 
            {/* {message && <p className="message">{message}</p>} */}
          </>
        )}
      </div>
    </section>
  );
};
 
export default ForgotPassword;
 
 